import React from "react";
import validator from 'validator';
import {default as MessagesValidator} from '../../helpers/validator-messages';
import '../../helpers/validator-extends';


export default React.createClass({
	getInitialState: function () {
		return {
			isSubmitting: false,
			isValid: false,
			isLoading: this.props.loading
		};
	},
	componentWillReceiveProps: function(nextProps){
		if(nextProps.loading == false)
			this.setState({
				isLoading: false
			});
	},
	componentWillMount: function(){
		this.model = {};
		this.inputs = {};
		this.allValidations = [];
	},
	componentDidMount: function () {

	},
	renderAndRegisterChildren: function(children){
		return React.Children.map(children, child => {
			if(child)
			{
				if(!(typeof child === 'object')) return child;

				var childProps = {};

				if (child.props.name !== undefined)
					childProps = {
						attachToForm: this.attachToForm,
						detachFromForm: this.detachFromForm,
						validate: this.validate,
						changeField: this.changeField
					};

				childProps.children = this.renderAndRegisterChildren(child.props.children);
				return React.cloneElement(child, childProps);
			}
		});
	},
	attachToForm: function(component){
		this.inputs[component.props.name] = component;
		this.model[component.props.name] = component.state.value;
	},
	detachFromForm: function(component){
		delete this.inputs[component.props.name];
		delete this.model[component.props.name];
	},
	validate: function(component){
		// We initially set isValid to true and then flip it if we
		// run a validator that invalidates the input
		var isValid = true,
			message = '',
			that = this;

		// If no validations property, do not validate
		if (!component.props.validations) {
			component.setState({
				isValid: isValid,
				validationError: message,
				isAfterValidate: true
			});

			that.allValidations[component.props.name] = true;

			return;
		}

		// We only validate if the input has value or if it is required
		if (component.props.value || component.props.required) {

			// We split on comma to iterate the list of validation rules
			component.props.validations.split(',').forEach(function (validation) {
				// By splitting on ":"" we get an array of arguments that we pass
				// to the validator. ex.: isLength:5 -> ['isLength', '5']

				var args = validation.split(':'),
					validateMethod = args.shift(),
					value = component.state.value.toString();

				args = args.map(function (arg) {
					arg = arg.replace(/\'/g, '"').replace('-', ':');
					return JSON.parse(arg);
				});

				if(typeof args[0] === 'object') {
					var options = {};
					for (var name in args) {
						options = Object.assign(options, args[name]);
					}
					args = options;
				}

				args = [value].concat(args);

				if (!validator[validateMethod].apply(validator, args)) {
					isValid = false;
					that.allValidations[component.props.name] = false;

					if(MessagesValidator[validateMethod] != undefined)
						message += ' '+MessagesValidator[validateMethod];
					else if(MessagesValidator[validation] != undefined)
						message += ' '+MessagesValidator[validation];
				}else {
					that.allValidations[component.props.name] = true;
				}
			});
		}

		component.setState({
			isValid: isValid,
			validationError: message,
			isAfterValidate: true
		});

		// Now we set the state of the input based on the validation
		this.setState({
			isValid: this.checkAllValidations()
		});
	},
	changeField: function(key, callback) {
		callback(key, this.inputs, this);
	},
	checkAllValidations: function() {
		var isValid = true;

		for (var key in this.allValidations) {
			if(this.allValidations[key] == false)
				isValid = false;
		}

		return isValid;
	},
	updateModel: function(){
		return new Promise(function(resolve, reject) {
			Object.keys(this.inputs).forEach(function(name){
				this.model[name] = this.inputs[name].state.value._isAMomentObject
					? this.inputs[name].state.value.format('YYYY-MM-DD').toString()
					: this.inputs[name].state.value;

				let component = this.inputs[name];
				this.validate(component);
			}.bind(this));
			return resolve();
		}.bind(this));

	},
	submit: function (event) {
		event.preventDefault();

		this.updateModel().then(function(){
			if(this.state.isValid && this.beforeSend()){
				this.setState({
					isSubmitting: true
				});
				this.props.action(this);
			}
		}.bind(this));
	},
	afterSend: function() {
		this.setState({
			isSubmitting: false
		});
	},
	beforeSend: function() {
		if(this.props.beforeSend)
			return this.props.beforeSend();

		return true;
	},
	checkResponse: function (response) {
		if(typeof response === 'undefined') {
			this.setState({
				isSubmitting: false
			});
			throw Error('Błąd odpowiedzi');
		}
		else
			return response;
	},
	setErrorsOnInputs: function (response) {
		var errors = response,
			allIsValid = true;

		// We go through all inputs and check errors
		Object.keys(this.inputs).forEach(function (name) {
			let component = this.inputs[name],
				error = Array.isArray(errors) ? errors.find((error, i) => error.field === name) : undefined;

			if(error == undefined) {
				component.setState({
					isValid: true,
					validationError: '',
					isAfterValidate: true
				});
			}else{
				allIsValid = false;
				component.setState({
					isValid: false,
					validationError: error.message,
					isAfterValidate: true
				});
			}
		}.bind(this));

		this.setState({
			isValid: allIsValid,
			isSubmitting: false
		});

		if(allIsValid)
			return response;
		else
			throw new Error('Form is not valid');
	},
	onSuccess: function(response) {
		if(this.props.onSuccess)
			return this.props.onSuccess(response, this);
		
		return response;
	},
	onError: function(response) {
		if(this.props.onError)
			return this.props.onError(response, this);
		
		return response;
	},
	render: function(){
		if(this.state.isLoading == false)
			return (
				<div className={(this.state.isSubmitting ? 'loading-form' : '')}>
					<form className={"ui form " +(this.props.class ? this.props.class : '')} onSubmit={this.submit}>
						{this.renderAndRegisterChildren(this.props.children)}
						{this.props.addLinks !== undefined ? this.props.addLinks() : ''}
						<div className="wrap-button">
							<button
								type="submit"
								className="ui green button"
								onClick={this.resetValidation}
								disabled={this.state.isSubmitting}
							>{this.state.isSubmitting ? 'Zapisywanie....' : this.props.buttonSubmitTitle} </button>
						</div>
					</form>
				</div>
			);
		else
			return(<div className="loading-form"></div>);
	}
})



/** WEBPACK FOOTER **
 ** ./js/components/form/ui-semantic-form.js
 **/